import type { SVGProps } from 'react';

interface FishIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function FishIcon({ className, ...props }: FishIconProps) {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M16.2208 8.46265C16.0713 7.65178 16.0389 7.09115 16.1619 6.27072C16.3174 5.23063 16.6677 4.2297 16.9598 3.23258C15.6194 3.65187 14.3644 4.38538 13.1486 5.1313C12.6087 4.4465 11.9722 3.84957 11.2845 3.35579C11.0376 3.1791 10.396 2.86678 10.2712 2.62992C10.0081 2.13328 10.05 1.38066 10.2576 0.865872L10.6489 0.136183C8.98376 -0.303158 7.5536 0.361584 6.29857 1.54016C6.16872 1.66242 5.99785 1.93175 5.8697 2.01389C5.68345 2.13328 5.21955 2.20968 4.97948 2.30519C3.38358 2.94224 1.5852 4.54679 0.592457 6.07398C0.446365 6.29747 0.0140709 7.02142 0.000401523 7.26306C-0.0226656 7.69667 0.954696 9.01947 1.24432 9.37668C2.36777 10.7606 4.06961 12.1312 5.70823 12.5829C5.96624 12.6545 6.54206 12.6966 6.72318 12.7825C6.79922 12.8188 7.02818 13.1416 7.12984 13.2333C7.81161 13.8474 8.66509 14.1225 9.53822 13.9487C9.51174 13.751 9.35539 13.622 9.29132 13.4387C9.19905 13.1741 9.17598 12.8857 9.26142 12.6154C9.36223 12.2992 9.62793 12.3394 9.88935 12.2219C11.1897 11.6374 12.3584 10.8131 13.2777 9.62022C13.3887 9.58871 13.5784 9.79596 13.6877 9.85995C14.7522 10.4865 15.8458 11.0748 17 11.4712C16.7164 10.497 16.4037 9.46645 16.2191 8.4617L16.2208 8.46265ZM4.14137 7.70431C2.55743 7.93735 2.40023 5.30322 3.90301 5.24305C5.30242 5.1867 5.43142 7.51425 4.14137 7.70431Z" fill="currentColor" />
    </svg>
  );
}
